export default __webpack_public_path__ + "static/media/collection_C2.fde42040.jpg";